(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "polished", "../palette/index"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("polished"), require("../palette/index"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.polished, global.index);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _polished, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.warningColor = _exports.textColor = _exports.successColor = _exports.overlayColor = _exports.errorColor = _exports.darkWarningColor = _exports.darkTextColor = _exports.darkSuccessColor = _exports.darkErrorColor = _exports.darkBaseColor = _exports.cardBaseColor = _exports.borderColor = _exports.baseColor = void 0;

  /*
   |------------------------------------------------------------------------------
   | Base
   |------------------------------------------------------------------------------
   */

  var baseColor = _index.blueGrey;
  _exports.baseColor = baseColor;
  var darkBaseColor = (0, _polished.darken)(0.05, baseColor);
  _exports.darkBaseColor = darkBaseColor;
  var borderColor = _index.mediumGrey;

  /*
   |------------------------------------------------------------------------------
   | Text
   |------------------------------------------------------------------------------
   */
  _exports.borderColor = borderColor;
  var textColor = _index.white;
  _exports.textColor = textColor;
  var darkTextColor = _index.black;

  /*
   |------------------------------------------------------------------------------
   | Status
   |------------------------------------------------------------------------------
   */
  _exports.darkTextColor = darkTextColor;
  var successColor = _index.green;
  _exports.successColor = successColor;
  var darkSuccessColor = _index.darkGreen;
  _exports.darkSuccessColor = darkSuccessColor;
  var warningColor = _index.yellow;
  _exports.warningColor = warningColor;
  var darkWarningColor = _index.darkYellow;
  _exports.darkWarningColor = darkWarningColor;
  var errorColor = _index.red;
  _exports.errorColor = errorColor;
  var darkErrorColor = _index.darkRed;

  /*
   |------------------------------------------------------------------------------
   | Elements
   |------------------------------------------------------------------------------
   */
  _exports.darkErrorColor = darkErrorColor;
  var cardBaseColor = _index.white;
  _exports.cardBaseColor = cardBaseColor;
  var overlayColor = (0, _polished.transparentize)(0.25, _index.black);
  _exports.overlayColor = overlayColor;
});